// src/components/UserManagement/FindUserModal.jsx
import React, { useEffect } from "react";
import { Modal, Form, Input, DatePicker, Button, Space } from "antd";

export default function FindUserModal({ open, onCancel, onFind }) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [open, onCancel]);

  const handleFind = () => {
    form.validateFields().then((values) => {
      const payload = {
        ...values,
        dob: values.dob ? values.dob.format("YYYY-MM-DD") : null, // ✅ format for backend
      };
      onFind(payload); // Pass search payload to parent
    });
  };

  return (
    <Modal
      title="Find User"
      open={open}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      footer={null}
      width={500}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Username">
          <Input placeholder="Enter username" />
        </Form.Item>
        <Form.Item name="dob" label="Date of Birth">
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item name="mobileNo" label="Mobile Number">
          <Input placeholder="Enter mobile number" />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" onClick={handleFind}>
              Find
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}
